import { SOCIALS } from "../config";

// BookingDialog listens for this; detail: { service }
export const BOOKING_EVENT = "open-booking";

// a1 prefills the first invitee question on the Calendly event
export const calendlyUrl = (service, base = SOCIALS.calendly) => {
  const url = new URL(base);
  url.searchParams.set("embed_type", "Inline");
  url.searchParams.set("embed_domain", window.location.hostname);
  url.searchParams.set("hide_gdpr_banner", "1");
  if (service) url.searchParams.set("a1", service);
  return url.toString();
};

export const openBooking = (service) =>
  window.dispatchEvent(new CustomEvent(BOOKING_EVENT, { detail: { service } }));
